/*
  设备完好率--设备完好率趋势
 */
import React, { Component } from "react";
import { Modal } from "antd";
import StubStatusLog from "@/pages/configurationManagement/stub/stubStatusLog";
import StubIntactDetailInner from "./stubIntactDetailInner";
import "@/assets/stylus/data_analysis.styl";

class StuIntactDetail extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {};
    this.layout = [
      "inline", // 横向布局
      "vertical", // 弹窗布局
      "horizontal", // 纵向布局
    ];
  }

  /**
   *  新开页传入参数设置
   */
  componentWillMount() {
    this.query = {};

    if (window.LayoutTab && window.LayoutTab.tabParam) {
      this.query["stubId"] = window.LayoutTab.tabParam.stubId;
    }

    this.setState({
      stubId: this.query.stubId,
    });
  }

  // 查看详情 传递参数分别为： 停止原因 是否成功（0: 全部 1：成功 2：失败 其他全部）
  handleOrderDetailBtnClick(detailEndcode, isSuccess) {
    this.setState({
      detailEndCode: detailEndcode,
      isSuccess: isSuccess,
    });
    this.modalVisibleAction("seeOrderDetailVisible", true);
  }

  // 模态框 开启/关闭 统一方法
  modalVisibleAction(modalVisibleKey, visible) {
    this.setState({
      [modalVisibleKey]: visible,
    });
  }

  // 获取选取的日期
  changeDay = (value) => {
    console.log(value);
  };

  init() {}

  render() {
    const val = (
      <div className='analysis-content-3'>
        <div style={{ padding: "20px" }}>
          <StubIntactDetailInner stubId={this.state.stubId} changeDay={this.changeDay} />
        </div>
        <div className='titleChart' style={{ fontSize: "14px" }}>
          充电桩-{this.state.stubId}近7天完好率情况{" "}
          <a
            onClick={() => {
              this.modalVisibleAction("seeDetailVisible", true);
            }}>
            状态日志
          </a>
        </div>

        <Modal
          title='状态日志'
          visible={this.state.seeDetailVisible}
          footer={null}
          destroyOnClose
          width='800px'
          onCancel={() => {
            this.modalVisibleAction("seeDetailVisible", false);
          }}>
          <StubStatusLog stubIdData={this.state.stubId} />
        </Modal>
      </div>
    );

    return val;
  }
}

export default StuIntactDetail;



// WEBPACK FOOTER //
// ./src/AntD/pages/indicatorReport/stubIntactRate/stuIntactDetail.js